import $ from 'jquery'

import BaseComponent from 'scripts/components/base-component'
import alert from 'scripts/utils/alert'

const DEFAULTS = {
  messages: {
    detectionError: 'O código não pôde ser detectado. Tente novamente.'
  },
  config: {
    inputStream: {
      size: 800
    },
    decoder: {
      readers: ['ean_reader', 'code_128_reader']
    },
    locate: true,
    locator: {
      patchSize: 'small'
    }
  }
}

class BarcodeReader extends BaseComponent {
  static componentName = 'barcode-reader'

  static DOMEvents = {
    'change [data-input-file]': 'onFileInputChange'
  }

  constructor (element) {
    super(element)

    this.options = $.extend({}, DEFAULTS)
  }

  init () {
    if (this.checkBrowserSupport()) {
      this.setupElements()
    } else {
      this.disableBarcodeButton()
    }
  }

  setupElements () {
    this.$searchInput = $('[data-mobile-search-input]')
    this.$searchForm = $('[data-search="mobile"] form')
  }

  onFileInputChange (e) {
    if (e.target.files && e.target.files.length) {
      this.fileSrc = window.URL.createObjectURL(e.target.files[0])

      this.options.config = $.extend({ src: this.fileSrc }, this.options.config)

      quagga.decodeSingle(this.options.config, this.onProcessedCode.bind(this))
    }
  }

  onProcessedCode (result) {
    if (result && result.codeResult) {
      const { code } = result.codeResult

      this.setSearchInput(code)
      this.submitForm()
    } else {
      alert(this.options.messages.detectionError)
    }
  }

  setSearchInput (ean) {
    this.$searchInput.val(ean)
  }

  submitForm () {
    this.$searchForm.submit()
  }

  checkBrowserSupport () {
    return navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function'
  }

  disableBarcodeButton () {
    this.$element.hide()
  }
}

export default ($el) => new BarcodeReader($el).init()

export { BarcodeReader as Component }
